import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList }) {
    return InboxMembersAPI.update({ inboxId, agentList });
  },
  updateRole(_, { inboxId, userId, role, autoAssign }) {
    return InboxMembersAPI.updateRole({ inboxId, userId, role, autoAssign });
  },
};

export default {
  namespaced: true,
  actions,
};
